import ChannelsV2Cards from './ChannelsV2Cards'
export default ChannelsV2Cards
